import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import get from "lodash/get";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import Select from "react-select";
import {
  removeSelectedFilters,
  setSelectedFilters,
} from "../../../Actions/FilterAction";
import { DateRangeCx, DatePickerComponent } from "../../../Component/Custom";
import DrawerHeader from "../../../Component/Headers/drawerHeader";
import "./index.style.css";

class FilterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: null,
      selectedFilters: [],
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.onFilterSave = this.onFilterSave.bind(this);
    this.onSelectFilter = this.onSelectFilter.bind(this);
    this.onCloseFilter = this.onCloseFilter.bind(this);
    this.ConvertDate = this.ConvertDate.bind(this);
    this.onClearAll = this.onClearAll.bind(this);
    this.changeDateType = this.changeDateType.bind(this);
  }

  componentWillUnmount() {
    this.props.removeSelectedFilters();
  }

  componentDidMount() {
    this.setState({
      selectedFilters: this.props.parentState.filterOptions,
      parentState: this.props.parentState,
      empattr: this.props.parentState.empattr,
      drawerOpen: this.props.drawerOpen,
      language: this.props.language,
    });
  }

  onInputChange(filter, event) {
    const { selectedFilters } = this.state;

    const selectedFilter = selectedFilters && selectedFilters.find(
      (option) => option.displayname === filter.displayname,
    );
    if (selectedFilter.displayvalue == 0 && event.target.value < 0) {
      selectedFilter.value = "90";
    } else {
      selectedFilter.value = event.target.value;
    }
    const currentFilterIndex =
      selectedFilters &&
      selectedFilters.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );

    if (currentFilterIndex === -1) {
      selectedFilters && selectedFilters.push(selectedFilter);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     this.state.selectedFilter.value,
        //     this.state.selectedFilter,
        //   );
        // },
      );
    } else {
      selectedFilters[currentFilterIndex] = selectedFilter;
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     this.state.selectedFilter.value,
        //     this.state.selectedFilter,
        //   );
        // },
      );
    }
    // this.props.setSelectedFilters(selectedFilters);
  }

  onPhoneChange(filter, field, value) {
    const selectedFilter = this.props.parentState.filterOptions.find(
      (option) => option.displayname === filter.displayname,
    );
    const mobile = JSON.parse(JSON.stringify(field));
    let no = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    no = no.replace(value.dialCode, "");
    no = no.trim();
    selectedFilter.value = no || "";
    selectedFilter.mobile = mobile || "";

    const currentFilterIndex =
      this.state.selectedFilters &&
      this.state.selectedFilters.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );

    if (currentFilterIndex === -1) {
      const { selectedFilters } = this.state;
      selectedFilters && selectedFilters.push(selectedFilter);
      // this.props.setSelectedFilters(selectedFilters);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     this.state.selectedFilter.value,
        //     this.state.selectedFilter,
        //   );
        // },
      );
    } else {
      const { selectedFilters } = this.state;
      selectedFilters[currentFilterIndex] = selectedFilter;
      // this.props.setSelectedFilters(selectedFilters);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     this.state.selectedFilter.value,
        //     this.state.selectedFilter,
        //   );
        // },
      );
    }
  }

  ConvertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  onSelectDate(filter, event) {
    console.log("filter, event: ", filter, event);
    const selectedFilter = this.props.parentState.filterOptions.find(
      (option) => option.displayname === filter.displayname,
    );

    if (selectedFilter.type == "bdate" || selectedFilter.type == "madate") {
      if (selectedFilter.toggle) {
        selectedFilter.value1 = event.startdate;
        selectedFilter.value2 = event.enddate;
        selectedFilter.value = `${selectedFilter.value1} - ${selectedFilter.value2}`;
      } else {
        selectedFilter.value = event.value;
      }
    } else if (
      selectedFilter.type == "jdate" ||
      selectedFilter.type == "edate" ||
      selectedFilter.type == "ndate"
    ) {
      if (selectedFilter.toggle) {
        selectedFilter.value1 = event.startdate;
        selectedFilter.value2 = event.enddate;
        selectedFilter.value = `${selectedFilter.value1} - ${selectedFilter.value2}`;
      } else {
        selectedFilter.value = event.value;
      }
    }
    console.log("selectedFilter: ", selectedFilter);

    const currentFilterIndex =
      this.state.selectedFilters &&
      this.state.selectedFilters.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );

    if (currentFilterIndex === -1) {
      const { selectedFilters } = this.state;
      selectedFilters && selectedFilters.push(selectedFilter);
      // this.props.setSelectedFilters(selectedFilters);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     this.state.selectedFilter.value,
        //     this.state.selectedFilter,
        //   );
        // },
      );
    } else {
      const { selectedFilters } = this.state;
      selectedFilters[currentFilterIndex] = selectedFilter;
      // this.props.setSelectedFilters(selectedFilters);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     this.state.selectedFilter.value,
        //     this.state.selectedFilter,
        //   );
        // },
      );
    }
  }

  onSelectFilter(filter, event) {
    const selectedFilter = this.props.parentState.filterOptions.find(
      (option) => option.displayname === filter.displayname,
    );
    if (filter.displayname == "Self Service") {
      if (event.displayvalue === true) {
        selectedFilter.value = event.displayvalue;
      } else if (event.displayvalue === false) {
        selectedFilter.value = event.displayvalue;
      } else {
        selectedFilter.value = "";
      }
    } else if (filter.displayname != "Self Service") {
      if (event.displayvalue || event.employeeid) {
        const selectedOption = selectedFilter.options.find((object) => {
          if (
            (object.displayvalue || object.employeeid) ==
            (event.displayvalue || event.employeeid)
          ) {
            return (
              (object.displayvalue || object.employeeid) ==
                event.displayvalue || event.employeeid
            );
          }
        });
        if (selectedFilter.displayname == "Bank name") {
          selectedFilter.value = event.displayname;
        } else {
          selectedFilter.value =
            selectedOption.displayvalue || selectedOption.employeeid;
        }
      } else {
        selectedFilter.value = "";
      }
    }

    const currentFilterIndex =
      this.state.selectedFilters &&
      this.state.selectedFilters.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );

    if (currentFilterIndex === -1) {
      const { selectedFilters } = this.state;
      selectedFilters && selectedFilters.push(selectedFilter);
      // this.props.setSelectedFilters(selectedFilters);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   if (filter.displayname == "Self Service") {
        //     this.props.onFilterValueChange(
        //       this.state.selectedFilter && this.state.selectedFilter.value,
        //       this.state.selectedFilter,
        //     );
        //   } else {
        //     this.props.onFilterValueChange(
        //       (this.state.selectedFilter &&
        //         this.state.selectedFilter.value.displayvalue) ||
        //         (this.state.selectedFilter &&
        //           this.state.selectedFilter.value.employeeid) ||
        //         (this.state.selectedFilter && this.state.selectedFilter.value),
        //       this.state.selectedFilter,
        //     );
        //   }
        // },
      );
    } else {
      const { selectedFilters } = this.state;
      selectedFilters[currentFilterIndex] = selectedFilter;
      // this.props.setSelectedFilters(selectedFilters);
      this.setState(
        {
          selectedFilter,
          selectedFilters,
        },
        // () => {
        //   this.props.onFilterValueChange(
        //     (this.state.selectedFilter &&
        //       this.state.selectedFilter.value.displayvalue) ||
        //       (this.state.selectedFilter &&
        //         this.state.selectedFilter.value.employeeid) ||
        //       (this.state.selectedFilter && this.state.selectedFilter.value),
        //     this.state.selectedFilter,
        //   );
        // },
      );
    }
  }

  changeDateType(filter, event) {
    const selectedFilter = this.props.parentState.filterOptions.find(
      (option) => option.displayname === filter.displayname,
    );
    const { selectedFilters } = this.state;
    const currentFilterIndex =
      this.state.selectedFilters &&
      this.state.selectedFilters.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );
    if(selectedFilters) selectedFilters[currentFilterIndex] = selectedFilter;
    if (event == "true") {
      selectedFilter.toggle = true;
    } else {
      selectedFilter.toggle = false;
    }

    if (currentFilterIndex === -1) {
      selectedFilters && selectedFilters.push(selectedFilter);
      // this.props.setSelectedFilters(selectedFilters);
      this.setState({
        selectedFilter,
        selectedFilters,
      });
    } else {
      selectedFilters[currentFilterIndex] = selectedFilter;
      // this.props.setSelectedFilters(selectedFilters);
      this.setState({
        selectedFilter,
        selectedFilters,
      });
    }
  }

  onFilterSave() {
    const { selectedFilters } = this.state;
    const filters = selectedFilters && selectedFilters.filter((filter) => {
      if (Array.isArray(filter.value)) {
        if (filter.value.length > 0) {
          return filter;
        }
      }
      if (filter.value || typeof filter.value == "boolean") {
        return filter;
      }
    });
    console.log("filters: ", filters);
    this.props.onFilterSave(false, filters, selectedFilters);
  }

  onCloseFilter() {
    this.props.handleClickAway(false);
  }

  onClearAll() {
    this.setState(
      {
        selectedFilter: null,
        selectedFilters: [],
      },
      () => {
        this.props.resetFilters(false);
      },
    );
  }

  render() {
    const { selectedFilters, empattr, drawerOpen, language } = this.state;
    const parentState = {
      filterOptions: selectedFilters
    };
    console.log("Bhai render hogya");
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <Drawer anchor="right" open={drawerOpen} onClose={this.onCloseFilter}>
            <div className="probation-planner-drawer" style={{ width: 320 }}>
              <DrawerHeader
                header="Filter & Sort"
                isbackarrow={false}
                closeDrawer={this.onCloseFilter}
              />
              <div className="drawer-form">
                {selectedFilters &&
                  selectedFilters.map((option, index) => {
                    if (option.type === "input") {
                      // const filter = this.state.selectedFilters.find((filter1) => filter1.displayname === option.displayname);
                      return (
                        <div className="planner-filter-edit">
                          {empattr && index == 0 && (
                            <div
                              style={{
                                fontSize: 19,
                                fontWeight: "bold",
                                opacity: 0.7,
                                marginBottom: 16,
                              }}
                            >
                              Employee Attributes
                            </div>
                          )}
                          {empattr && index == 0 && (
                            <div
                              style={{
                                fontSize: 16,
                                fontWeight: "bold",
                                opacity: 0.7,
                                marginBottom: 8,
                              }}
                            >
                              Personal Information
                            </div>
                          )}
                          <InputLabel className="planner-label">
                            {option.displayname}
                          </InputLabel>
                          <TextField
                            className="text-input width100"
                            onChange={(event) =>
                              this.onInputChange(option, event)
                            }
                            value={get(option, "value", "")}
                            id="outlined-bare"
                            placeholder={option.displayname}
                            type="text"
                            margin="normal"
                            variant="outlined"
                          />
                        </div>
                      );
                    } else if (option.type === "select") {
                      let filter = null;
                      let sfilter = null;
                      if (option.displayname == "Bank Name") {
                        filter = this.state.selectedFilters.find(
                          (filter1) =>
                            filter1.displayname === option.displayname,
                        );

                        sfilter =
                          filter &&
                          filter.options &&
                          filter.options.find(
                            (option1) => option1.displayname == filter.value,
                          );
                      } else if (option.displayname == "Self Service") {
                        filter = this.state.selectedFilters.find(
                          (filter1) =>
                            filter1.displayname === option.displayname,
                        );
                        sfilter =
                          filter &&
                          filter.options &&
                          filter.options.find(
                            (option1) => option1.displayvalue == filter.value,
                          );
                      } else {
                        filter = this.state.selectedFilters.find(
                          (filter1) =>
                            filter1.displayname === option.displayname,
                        );
                        sfilter =
                          filter &&
                          filter.options &&
                          filter.options.find(
                            (option1) =>
                              option1.displayvalue == filter.value ||
                              option1.employeeid == filter.value,
                          );
                      }
                      return (
                        <div className="planner-filter-edit">
                          <div
                            style={{
                              fontSize: 16,
                              opacity: 0.7,
                              fontWeight: "bold",
                              marginBottom: 8,
                              marginTop: 16,
                            }}
                          >
                            {option.displayname == "Employment Stage" &&
                              "Job Status"}
                            {option.displayname == "Office Location" &&
                              "Placement"}
                            {option.displayname == "Manager’s Team Members" &&
                              "Managerial"}
                          </div>
                          <div className="planner-label">
                            {option.displayname}
                          </div>
                          <Select
                            className="select-multiple"
                            onChange={(event) =>
                              this.onSelectFilter(option, event)
                            }
                            options={option.options}
                            getOptionLabel={(option1) =>
                              option1.displayname || option1.fullname
                            }
                            getOptionValue={(option1) =>
                              option1.displayvalue || option1.employeeid
                            }
                            value={sfilter && sfilter}
                          />
                        </div>
                      );
                    } else if (option.type === "phone") {
                      const filter = this.state.selectedFilters.find(
                        (filter1) => filter1.displayname === option.displayname,
                      );
                      return (
                        <div
                          className="planner-filter-edit position-rel"
                          style={{ zIndex: 0 }}
                        >
                          <div
                            style={{
                              fontSize: 16,
                              opacity: 0.7,
                              fontWeight: "bold",
                              marginBottom: 8,
                              marginTop: 16,
                            }}
                          >
                            Contact & pay
                          </div>
                          <InputLabel
                            className="planner-label"
                            style={{ marginBottom: 2 }}
                          >
                            {option.displayname}
                          </InputLabel>
                          <ReactPhoneInput
                            defaultCountry={"in"}
                            // onChange={(value) => { this.setMobile(option, value) }}
                            onChange={(filed, value) =>
                              this.onPhoneChange(option, filed, value)
                            }
                            countryCodeEditable={false}
                            value={filter && filter.mobile}
                            InputProps={{ maxLength: 15, minLength: 5 }}
                          />
                        </div>
                      );
                    } else if (option.type === "bdate") {
                      const filter = parentState.filterOptions.find(
                        (filter1) => filter1.type == "bdate",
                      );
                      const x = parentState.filterOptions[index].toggle;
                      return (
                        <div>
                          <div
                            style={{
                              fontSize: 16,
                              opacity: 0.7,
                              fontWeight: "bold",
                              marginBottom: 8,
                              marginTop: 16,
                            }}
                          >
                            Personal Dates
                          </div>

                          <div className="filter-datepicker position-rel">
                            <InputLabel className="planner-label">
                              {option.displayname}
                            </InputLabel>
                            <div>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  aria-label=""
                                  name=""
                                  value={x}
                                  onChange={(e) =>
                                    this.changeDateType(option, e.target.value)
                                  }
                                  row
                                >
                                  <FormControlLabel
                                    value={true}
                                    control={<Radio />}
                                    label="In-between"
                                  />
                                  <FormControlLabel
                                    value={false}
                                    control={<Radio />}
                                    label="Specific"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                            {filter && filter.toggle ? (
                              <DateRangeCx
                                startdate={
                                  parentState.filterOptions[index].value1
                                }
                                enddate={
                                  parentState.filterOptions[index].value2
                                }
                                minDetail="year"
                                customFormat="dd MMM"
                                depth="year"
                                onClose={(e) => this.onSelectDate(option, e)}
                              />
                            ) : (
                              <DatePickerComponent
                                top="year"
                                customFormat="dd MMM"
                                onChange={(e) => this.onSelectDate(option, e)}
                                value={filter && filter.value}
                              />
                            )}
                          </div>
                        </div>
                      );
                    } else if (option.type === "jdate") {
                      const filter = this.state.selectedFilters.find(
                        (filter1) => filter1.type == "jdate",
                      );
                      const x = parentState.filterOptions[index].toggle;
                      return (
                        <div className="filter-datepicker position-rel">
                          <div
                            style={{
                              borderTop: "1px solid #d4d4d4",
                              marginBottom: 16,
                              marginTop: 16,
                            }}
                          ></div>
                          <div
                            style={{
                              fontSize: 19,
                              opacity: 0.7,
                              fontWeight: "bold",
                              marginBottom: 16,
                            }}
                          >
                            Company Attributes
                          </div>
                          <div
                            style={{
                              fontSize: 16,
                              opacity: 0.7,
                              fontWeight: "bold",
                              marginBottom: 8,
                            }}
                          >
                            Dates
                          </div>
                          <InputLabel className="planner-label">
                            {option.displayname}
                          </InputLabel>
                          <div>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-label=""
                                name=""
                                value={x}
                                onChange={(e) =>
                                  this.changeDateType(option, e.target.value)
                                }
                                row
                              >
                                <FormControlLabel
                                  value={true}
                                  control={<Radio />}
                                  label="In-between"
                                />
                                <FormControlLabel
                                  value={false}
                                  control={<Radio />}
                                  label="Specific"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          {filter && filter.toggle ? (
                            <DateRangeCx
                              startdate={
                                parentState.filterOptions[index].value1
                              }
                              enddate={parentState.filterOptions[index].value2}
                              onClose={(e) => this.onSelectDate(option, e)}
                            />
                          ) : (
                            <DatePickerComponent
                              onChange={(e) => this.onSelectDate(option, e)}
                              value={filter && filter.value}
                            />
                          )}
                        </div>
                      );
                    } else if (option.type === "madate") {
                      const filter = this.state.selectedFilters.find(
                        (filter1) => filter1.type == "madate",
                      );
                      const x = parentState.filterOptions[index].toggle;
                      return (
                        <div className="filter-datepicker position-rel">
                          <InputLabel className="planner-label">
                            {option.displayname}
                          </InputLabel>
                          <div>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-label=""
                                name=""
                                value={x}
                                onChange={(e) =>
                                  this.changeDateType(option, e.target.value)
                                }
                                row
                              >
                                <FormControlLabel
                                  value={true}
                                  control={<Radio />}
                                  label="In-between"
                                />
                                <FormControlLabel
                                  value={false}
                                  control={<Radio />}
                                  label="Specific"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          {filter && filter.toggle ? (
                            <DateRangeCx
                              startdate={
                                parentState.filterOptions[index].value1
                              }
                              enddate={parentState.filterOptions[index].value2}
                              minDetail="year"
                              customFormat="dd MMM"
                              onClose={(e) => this.onSelectDate(option, e)}
                            />
                          ) : (
                            <DatePickerComponent
                              top="year"
                              customFormat="dd MMM"
                              onChange={(e) => this.onSelectDate(option, e)}
                              value={filter && filter.value}
                            />
                          )}
                        </div>
                      );
                    } else if (option.type === "edate") {
                      const filter = this.state.selectedFilters.find(
                        (filter1) => filter1.type == "edate",
                      );
                      const x = parentState.filterOptions[index].toggle;
                      return (
                        <div className="filter-datepicker position-rel">
                          <InputLabel className="planner-label">
                            {option.displayname}
                          </InputLabel>
                          <div>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-label=""
                                name=""
                                value={x}
                                onChange={(e) =>
                                  this.changeDateType(option, e.target.value)
                                }
                                row
                              >
                                <FormControlLabel
                                  value={true}
                                  control={<Radio />}
                                  label="In-between"
                                />
                                <FormControlLabel
                                  value={false}
                                  control={<Radio />}
                                  label="Specific"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          {filter && filter.toggle ? (
                            <DateRangeCx
                              startdate={
                                parentState.filterOptions[index].value1
                              }
                              enddate={parentState.filterOptions[index].value2}
                              onClose={(e) => this.onSelectDate(option, e)}
                            />
                          ) : (
                            <DatePickerComponent
                              onChange={(e) => this.onSelectDate(option, e)}
                              value={filter && filter.value}
                            />
                          )}
                        </div>
                      );
                    } else if (option.type === "ndate") {
                      const filter = this.state.selectedFilters.find(
                        (filter1) => filter1.type == "ndate",
                      );
                      const x = parentState.filterOptions[index].toggle;
                      return (
                        <div className="filter-datepicker position-rel">
                          <InputLabel className="planner-label">
                            {option.displayname}
                          </InputLabel>
                          <div>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-label=""
                                name=""
                                value={x}
                                onChange={(e) =>
                                  this.changeDateType(option, e.target.value)
                                }
                                row
                              >
                                <FormControlLabel
                                  value={true}
                                  control={<Radio />}
                                  label="In-between"
                                />
                                <FormControlLabel
                                  value={false}
                                  control={<Radio />}
                                  label="Specific"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          {filter && filter.toggle ? (
                            <DateRangeCx
                              startdate={
                                parentState.filterOptions[index].value1
                              }
                              enddate={parentState.filterOptions[index].value2}
                              onClose={(e) => this.onSelectDate(option, e)}
                            />
                          ) : (
                            <DatePickerComponent
                              onChange={(e) => this.onSelectDate(option, e)}
                              value={filter && filter.value}
                            />
                          )}
                        </div>
                      );
                    }
                    return "";
                  })}
              </div>
              <div className="filter-buttons">
                <Button
                  onClick={this.onFilterSave}
                  className="planner-filter-save-button"
                >
                  Apply Filter
                </Button>
                <Button
                  onClick={this.onClearAll}
                  className="planner-filter-cancel-button"
                >
                  Reset
                </Button>
              </div>
            </div>
          </Drawer>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateminDetailrops = (state) => ({
  selectedFilters: state.FilterReducer.selectedFilters,
});

const mapDispatchminDetailrops = {
  setSelectedFilters,
  removeSelectedFilters,
};

export default connect(
  mapStateminDetailrops,
  mapDispatchminDetailrops,
)(FilterComponent);
